import React, {useEffect, useState} from 'react';
import {Card, Col, Flex, message, Row, Tag} from "antd";
import MyText from "../../../../components/UI/Text/MyText";
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import BlockLoading from "../../../../components/LoadingComponents/BlockLoading";
import {LocalName} from "../../../../utils/LocalName";
import {CalendarOutlined, FolderOutlined, TeamOutlined} from "@ant-design/icons";
import GreyButton from "../../../../components/UI/Buttons/GreyButton";
import {clrs} from "../../../../constants/colors";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import GroupService from "../../../../services/GroupService";

const StudentGroupsPage = () => {
    const navigate = useNavigate();
    const {user} = useSelector(state => state.user);
    const [journals, setJournals] = useState([]);
    const [isLoading, setLoading] = useState(false);
    // Отчисление: groupId -> 'yyyy-MM-dd' — группа остаётся в списке, но с пометкой
    const [leaveDates, setLeaveDates] = useState({});

    useEffect(() => {
        setLoading(true);
        handleFetchData();
        GroupService.getStudentLeaveDates(user.id)
            .then((r) => setLeaveDates(r.data || {}))
            .catch(() => setLeaveDates({}));
    }, []);

    async function handleFetchData() {
        setLoading(true);
        await GroupService.getGroupsByStudent(user.id)
            .then((r) => {
                setJournals(r);
                setLoading(false);
            })
            .catch(() => {
                message.destroy();
                message.error(<IntlMessage id={'error'}/>, 5);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} vertical gap={20}>
            <MyText uppercase strong size={"large"}><IntlMessage id={'ordersPage.groups'}/></MyText>
            <BlockLoading isLoading={isLoading}/>
            <Flex style={{width: '100%'}} justify={"flex-start"} align={"center"}>
                {!isLoading &&
                    <Row style={{width: '100%'}} gutter={[16, 16]} align={"middle"} justify={"start"}>
                        {
                            journals.map((journal) => (
                                <Col span={8} key={journal.id}>
                                    <Card title={LocalName.getName(journal) + " " + journal.number}>
                                        <Flex vertical gap={20} align={"flex-start"} justify={"center"}>
                                            {leaveDates[journal.id] &&
                                                <Tag color="default">
                                                    <IntlMessage id={'groups.expelledFrom'}
                                                                 values={{date: String(leaveDates[journal.id]).slice(0, 10).split('-').reverse().join('.')}}/>
                                                </Tag>
                                            }
                                            <MyText><FolderOutlined/> {LocalName.getName(journal.category)}
                                            </MyText>
                                            <MyText><CalendarOutlined/> <IntlMessage
                                                id={"ordersPage.academicYear"}/>:{journal.academicYear}</MyText>
                                            <MyText><TeamOutlined/> <IntlMessage
                                                id={"tg.students"}/>{journal.students.length}</MyText>
                                            <GreyButton onClick={() => navigate(`/p/group/${journal.id}`)}
                                                        backgroundColor={clrs.blackerBlue} fontColor={clrs.white}>
                                                Открыть
                                            </GreyButton>
                                        </Flex>
                                    </Card>
                                </Col>
                            ))
                        }
                    </Row>
                }
            </Flex>
        </Flex>
    );
};

export default StudentGroupsPage;